import React, { useContext } from 'react'
import { PayWithPointsDatasourceProps } from './PayWithPointsWrapper'
import ContentSlider from '../ContentSlider/ContentSlider'
import { getTextFieldValue } from '../../../helpers/layoutServiceHelper'
import PayWithPointsCard from '../../molecules/Card/PayWithPointsCard/PayWithPointsCard'
import { ShoppingBasketDiscountContext } from '../../../providers/ShoppingBasketDiscountProvider'

interface PointsForMerchandiseProps {
  datasource: PayWithPointsDatasourceProps
}
const PayWithPoints = ({ datasource }: PointsForMerchandiseProps) => {
  const { shoppingBasketDiscountData } = useContext(ShoppingBasketDiscountContext)

  return (
    <>
      <ContentSlider slidesPerPage={4} title={getTextFieldValue(datasource.title)}>
        {shoppingBasketDiscountData?.rewards?.map((item) => (
          <>
            <PayWithPointsCard
              key={item.rewardId}
              {...item}
              datasource={datasource}
            />
          </>
        ))}
      </ContentSlider>
    </>
  )
}

export default PayWithPoints
